// extracted by mini-css-extract-plugin
export default {"searchButton":"PhotoDay_searchButton__2quEX"};